import slugify from 'slugify';

/**
 * Converts a string to a slug from [MicroLibraryAppDetailsUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryAppDetailsUI)
 * @param stringSlugify - The string to convert to a slug
 * @returns The Slugify string
 */

export const stringSlugify = (stringToSlugify: string): string => {
  return slugify(stringToSlugify, {
    lower: true,
    strict: true,
  });
};
